<div [formGroup]="targetForm">
    <div class="row">
        <div class="col-md-12">
        <div class="target-container">
            <div class="target-date-column">
            <div>
                <span class="select-label text-info-800">
                Target Date
                <app-help-selector [selector]="1094"></app-help-selector>
                </span>
                <span class="alpaca-icon-required text-danger"></span>
            </div>
            <mat-form-field>
                <input matInput readonly (click)="targetDatePicker.open()" [matDatepicker]="targetDatePicker" formControlName="targetDate" placeholder="Target Date">
                <mat-datepicker-toggle matIconSuffix [for]="targetDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #targetDatePicker></mat-datepicker>
            </mat-form-field>
            <small class="hub-validation-error-message">
                {{getValidationErrorMessages('targetDate')}}
            </small>
            </div>
            <div class="target-value-column text-right">
            <div>
                <span class="select-label text-info-800 pb-2">
                Target Value
                <app-help-selector [selector]="1096"></app-help-selector>
                </span>
                <span class="alpaca-icon-required text-danger"></span>
            </div>
            @if (isScaleMeasure) {
                <mat-form-field >
                <input matInput type="number" class="form-control"
                    [formControl]="targetForm.controls.targetValue"
                    [value]="targetForm.controls.targetValue.value" placeholder="{{type | titlecase}} Value"
                    [min]="getScaleDefinitions()[0].scaleMeasureItem.value"
                    [max]="getScaleDefinitions()[getScaleDefinitions().length - 1].scaleMeasureItem.value"
                    step="1" />
                </mat-form-field>
            }
            @if (!isScaleMeasure) {
                <mat-form-field >
                <input matInput type="number" class="form-control"
                    formControlName="targetValue" placeholder="{{type | titlecase}} Value" />
                </mat-form-field>
            }
            <small class="hub-validation-error-message">
                {{getValidationErrorMessages('targetValue')}}
            </small>
            </div>
            <div class="unit-name-column">
            <span class="select-label text-info-800 d-block">
                Units<app-help-selector [selector]="1099"></app-help-selector>
            </span>
            <div class="form-control" disabled="disabled" style="padding-top: 13px; padding-bottom: 19px; height: 56px;">
                {{ unitName ? unitName : intermediateResult?.unit }}
            </div>
            </div>
        </div>
        </div>
    </div>
    @if (isScaleMeasure) {
        <div class="row">
        <div class="col-md-12">
            <div class="select-label text-info-800 mt-3 mb-2"> Target Value:</div>
        </div>
        <div class="scale-slider-panel">
            <div class="scale-slider-line"></div>
            <mat-radio-group [formControl]="targetForm.controls.targetValue"
            [value]="targetForm.controls.targetValue.value"
            style="display: flex; flex-direction: row; justify-content: space-between;">
            @for (scaleDefinition of getScaleDefinitions(); track scaleDefinition) {
                <mat-radio-button [matTooltip]="scaleDefinition.description || scaleDefinition.definition" matTooltipPosition="above"
                matTooltipShowDelay="500" matTooltipHideDelay="200"
                color="primary"
                [value]="scaleDefinition.scaleMeasureItem.value"></mat-radio-button>
            }
            </mat-radio-group>
            <div style="display: flex; flex-direction: row; justify-content: space-between;">
            @for (scaleDefinition of getScaleDefinitions(); track scaleDefinition; let i = $index) {
                <div class="scale-label"
                [ngClass]="{'first': i === 0, 'last': i === getScaleDefinitions().length - 1 }">
                {{scaleDefinition.scaleMeasureItem.label}}
                </div>
            }
            </div>
        </div>
        </div>
    }
</div>
